import {useCallback, useEffect, useState} from 'react';

import {isProduction} from '@/utils/environment';

const countryCodeStorage = 'is_country_show_visible';

export const useCountryCode = () => {
  const [isCountryCodeVisible, setIsCountryCodeVisible] = useState(false);

  useEffect(() => {
    const isCountryCodeVisibleStorage =
      localStorage.getItem(countryCodeStorage);
    setIsCountryCodeVisible(
      !isProduction && isCountryCodeVisibleStorage === 'true',
    );
  }, []);

  const setCountryCodeVisibleStorage = useCallback((value: boolean) => {
    localStorage.setItem(countryCodeStorage, value.toString());
    setIsCountryCodeVisible(value);
  }, []);

  const removeCountryCodeVisibleStorage = useCallback(() => {
    localStorage.removeItem(countryCodeStorage);
    setIsCountryCodeVisible(false);
  }, []);

  return {
    isCountryCodeVisible,
    setCountryCodeVisibleStorage,
    removeCountryCodeVisibleStorage,
  };
};
